import angular from 'angular';
export var ActionBarPosition = function ($window, $compile, $timeout) {
    'ngInject';
    return {
        restrict: 'A',
        link: function ($scope, $element, $attrs) {
            var targetEl = angular.element(document.querySelector($attrs.targetEl));
            var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
            if (targetEl) {
                targetEl.css('min-height', '84px');
                var replacementActions_1 = angular.element($element.clone());
                replacementActions_1.removeAttr('action-bar-position');
                replacementActions_1.css('position', 'absolute');
                replacementActions_1.css('transform', 'translateY(0px)');
                replacementActions_1.addClass('replacement-actions-tab');
                targetEl.append(replacementActions_1);
                $timeout(function () {
                    $scope.$apply(function () { return $compile(replacementActions_1)($scope); });
                });
                // do an initial check to see if the bar should be hidden
                if ($window.scrollY > targetEl[0].offsetTop - $window.innerHeight + $element[0].clientHeight) {
                    $element.css('transform', 'translateY(75px)');
                }
                $element.css('transition', 'transform 0.15s ease');
                var scrollEvent_1 = angular.element($window).bind('scroll', function () {
                    if ($window.scrollY > targetEl[0].offsetTop - $window.innerHeight + $element[0].clientHeight) {
                        $element.css('transform', 'translateY(75px)');
                    }
                    else {
                        function isIphoneUp6() {
                            var isIPhone = false;
                            isIPhone = !!navigator.userAgent.match(/iPhone/i);
                            if (isIPhone) {
                                var iHeight = window.screen.height;
                                var iWidth = window.screen.width;
                                if ((iWidth === 375 && iHeight === 667) || (iWidth === 414 && iHeight === 736)) {
                                    return true;
                                }
                            }
                            else {
                                return false;
                            }
                        }
                        if (isIphoneUp6()) {
                            $element.css('transform', 'translateY(-44px)');
                        }
                        else {
                            $element.css('transform', 'translateY(0px)');
                        }
                    }
                });
                if (isIE11) {
                    angular.element($element).remove();
                }
                $scope.$on('$destroy', function () {
                    angular.element($window).off('scroll', scrollEvent_1);
                });
            }
        }
    };
};
//# sourceMappingURL=action-bar-position.directive.js.map